import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  // Adds Bootstrap validation styling and blocks invalid form submissions.
  // Called by form submit actions using data-action="submit->bootstrap-validation#validate".
  validate(event) {
    this.element.classList.add("was-validated");

    // Let the browser submit normally when all native validations pass.
    if (this.element.checkValidity()) return;

    event.preventDefault();
    event.stopPropagation();
  }
}
